import { render, staticRenderFns } from "./CustomerShipmentStatus.vue?vue&type=template&id=40ac889e&scoped=true"
import script from "./CustomerShipmentStatus.vue?vue&type=script&lang=js"
export * from "./CustomerShipmentStatus.vue?vue&type=script&lang=js"
import style0 from "./CustomerShipmentStatus.vue?vue&type=style&index=0&id=40ac889e&prod&scoped=true&lang=scss"
import style1 from "./CustomerShipmentStatus.vue?vue&type=style&index=1&id=40ac889e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac889e",
  null
  
)

export default component.exports